import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { Container, ListGroup } from "react-bootstrap";

import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import classes from "./styles.module.scss";
import TickIcon from "./Tick.svg";

export default function ({
  className = "py-5",
  tagline,
  title,
  items,
  EditableText,
  theme = "light",
  section_id,
}) {
  return (
    <div
      className={cn(className, classes.BlueContentList)}
      data-bs-theme={theme}
      id={`${section_id}`}
    >
      <ParallaxBackground anim="y1:x0:z0" image={bg_1} floating={false} className={classes.bg_1} />
      <ParallaxBackground anim="y1:x0:z0" image={bg_2} floating={false} className={classes.bg_2} />
      <Container fluid="md">
        <Tagline as={EditableText} path="tagline" tag="strong" className="d-block mb-3">
          <span dangerouslySetInnerHTML={{ __html: tagline }} />
        </Tagline>
        <EditableText path="title" tag="h2" className="mb-4">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EditableText>
        <ListGroup>
          {items.map((i) => (
            <ListGroup.Item>
              <img className="svg" src={TickIcon} alt="" />
              {i}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </Container>
    </div>
  );
}
